import { Dialog } from "@mui/material";
import {CustomCloseModal} from "../../../../../_fri/components/CustomCloseModal/CustomCloseModal";
import {EcommerceDashboardModalPaymentContext} from "./EcommerceDashboardModalPaymentContext";
import {Transaction} from "../../../../../store/api/interface/ecommerce";

export interface IModalPayment {
    show: boolean;
    close: () => void;
    transaction: Transaction
    updateTransaction: (value:Transaction)=> void
}
export const EcommerceDashboardModalPayment = ({show, close, transaction, updateTransaction}: IModalPayment) => {
    return (
        <Dialog open={show} maxWidth={"xs"}>
            <CustomCloseModal onClickClose={close } title={"Esperando pago de compra #145"}/>
            <EcommerceDashboardModalPaymentContext updateTransaction={updateTransaction}  transaction={transaction} close={close}/>
        </Dialog>
    );
};